import React, {useState} from 'react';
import MainContainer from "../../UI/MainContainer";
import Header from "../../Layouts/Header/Header";
import SubMainContainer from "../../UI/SubMainContainer";
import SideBar from "../../Layouts/SideBar/SideBar";
import Navigation from "../Setting/Navigation";
import {Link} from "react-router-dom";
import AddEmployee from "../../Settings/Employee/AddEmployee";
import EmployeeData from "../../Settings/Employee/EmployeeData";
import EditEmployee from "../../Settings/Employee/EditEmployee";
import AccountsData from "../../Accounts/AccountsData";
import Pagination from "../../Customer/Pagination";

function Accounts(props) {

    return (
        <>
            {/*<div id="portal-root"></div>*/}
            <MainContainer>
                <Header />
                <SubMainContainer>
                    <SideBar />
                    <div className="rightCol">
                        <AccountsData/>

                    </div>
                </SubMainContainer>
            </MainContainer>
        </>

    );
}

export default Accounts;